<template>
  <div>
    <Logs :showForm="showLogs" :formData="formData" />

    <div>
      <div class="esocial-toolbar" v-if="!avulso">
        <div class="esocial-tabs">
          <div
            v-for="tabela in config.list.esocial_tabela"
            :key="tabela.id"
            class="esocial-tabs__item"
            :class="{ 'is-active': formData.layout == tabela.codigo }"
            @click="formData.layout = tabela.codigo"
          >
            <i class="fa fa-file-code-o"></i>
            <span>{{ tabela.codigo }}</span>
          </div>
        </div>

        <div class="esocial-search">
          <div class="esocial-search__group">
            <div class="esocial-search__input">
              <i class="fa fa-search"></i>
              <input
                type="text"
                v-model="formData.search"
                placeholder="Pesquisar por Consulta, Recibo, Lote, Funcionário, Empresa..."
                @keyup.enter="getEsocial(formData.search)"
              />
            </div>
            <button class="esocial-search__btn esocial-search__btn--attached" @click="getEsocial(formData.search)">
              <i class="fa fa-search"></i> Buscar
            </button>
          </div>
          <button class="esocial-search__btn esocial-search__btn--filter" @click="showFilterModal = true">
            <i class="fa fa-filter"></i> Filtrar
            <span class="esocial-search__badge" v-if="filterBadge > 0">{{ filterBadge }}</span>
          </button>
        </div>
      </div>

      <ed-table
        :onSearch="getEsocial"
        :onRegister="avulso ? onRegister : null"
        :onEdit="avulso ? onEditXml : null"
        :onClear="onClear"
        :onFilter="getEsocial"
        :tableHead="tableHead"
        :tableData="tableData"
        :loadingTable="config.loading.table"
        :pagination="pagination"
        :response="response"
        :filterBadge="filterBadge"
        :disableInputSearch="!avulso"
        registerName="Inserir novo XML"
      >
        <div slot="table-filter-content" v-if="avulso">
          <Filters :parent="this" />
        </div>
      </ed-table>

      <transition name="esocial-modal-fade">
        <div class="esocial-modal-overlay" v-if="showFilterModal" @click.self="showFilterModal = false">
          <div class="esocial-modal">
            <div class="esocial-modal__header">
              <span class="esocial-modal__title">Filtrar Resultado</span>
              <button class="esocial-modal__close" @click="showFilterModal = false">
                <i class="fa fa-times"></i>
              </button>
            </div>

            <div class="esocial-modal__body">
              <Filters :parent="this" v-if="showFilterModal" />
            </div>

            <div class="esocial-modal__footer">
              <button class="esocial-search__btn" @click="onClear(); showFilterModal = false">
                <i class="fa fa-refresh"></i> Limpar
              </button>
              <button class="esocial-search__btn esocial-search__btn--filter" @click="getEsocial(formData.search); showFilterModal = false">
                <i class="fa fa-filter"></i> Filtrar
              </button>
            </div>
          </div>
        </div>
      </transition>

      <s0000
        v-if="avulso" :parent="this"
      ></s0000>
       <s2210
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-2210'
        "
        :parent="this"
      ></s2210>
      <s2220
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-2220'
        "
        :parent="this"
      ></s2220>
      <s2240
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-2240'
        "
        :parent="this"
      ></s2240>
      <s3000
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-3000'
        "
        :parent="this"
      ></s3000>
    </div>

    <ed-modal 
      :title="'Atualizar dados do evento'" 
      :modal="showModalUid" 
      width="40%"
      :onSave="saveUid"
      :isModal="false"
    >
      <div slot="modal-content">
        <el-form :model="{ novoUid }" ref="ruleForm">
          <ed-alert class="px-3 mt-2" title="Atenção" type="warning">
            <p slot="description">
              Se o campo recibo for preenchido ou atualizado, o sistema alterará o status para "Processado com sucesso". Caso fique vazio, ele não altera o status atual do evento.
            </p>
          </ed-alert>
          <ed-input-text class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" label="Atualizar UID" v-model="novoUid" name="novoUid" required/>
          <ed-input-text class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" label="Adicionar/atualizar recibo" v-model="novoRecibo" name="novoRecibo" required/>
        </el-form>
      </div>
    </ed-modal>

  </div>
</template>

<script>
import EdTable from "common/table";
import Rest from "common/rest";
import { EdAlert, EdModal, EdInputText } from "template";
import Logs from "./includes/logs";
import Filters from "./includes/filter";

//layouts
import s0000 from "./s0000";
import s2210 from "./s2210";
import s2220 from "./s2220";
import s2240 from "./s2240";
import s3000 from "./s3000";

export default {
  name: "esocial",
  mixins: [Rest],
  components: {
    EdTable,
    Filters,
    Logs,
    s0000,
    s2220,
    s2210,
    s2240,
    s3000,
    EdAlert,
    EdModal,
    EdInputText
  },
  watch: {
    "formData.layout"(codigo) {
      this.formData.esocial_tabela = (this.config.list.esocial_tabela || []).find(
        (tabela) => tabela.codigo == codigo
      ) || null;

      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        tp_exa: [],
      };
      this.getEsocial();
    },
    "layout"() {
      this.formData.layout = this.layout
    },
    "lote"() {
      this.getEsocial()
    },
  },
  props: {
    layout: {
      type: String,
      default: function () {
        return null;
      },
    },
    lote: {
      type: [String,Number],
      default: function () {
        return null;
      },
    },
    avulso: {
      type: [Number],
      default: function () {
        return 0;
      },
    },
  },
  data() {
    return {
      config: {
        loading: {
          esocial_tabela: false,
          content: false,
          table: false,
          tableAntigo: false,
        },
        list: {
          esocial_tabela: [],
        },
      },
      formData: {
        layout: null,
        esocial_tabela:null,
        item: null,
        search: null,
        page: null,
        pagination: null,
        filter: null,
        empresa: null,
        arquivoConfig: {},
        result: {},
      },
      formDataXml:{

      },
      formFilter: {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:1,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        tp_exa: [],
      },
      pagination: {},
      response: {},
      filterBadge: 0,
      showFilterModal: false,
      showLogAntigo:false,
      showNovoXml:false,
      paginationAntigo: {},
      responseAntigo: {},
      filterBadgeAntigo: 0,
      tableHead: [],
      tableData: [],
      tableHeadAntigo: [],
      tableDataAntigo: [],
      showLogs: false,
      showModalUid: false,
      novoUid: null,
      novoRecibo: null,
      olduid: null,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.getEsocialTabela();
  },

  methods: {

    onClear(){
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status:[],
        tp_exa: []
      },

      this.getEsocial()
    },

    onRegister(){
      this.formDataXml = {}
      this.showNovoXml = !this.showNovoXml
    },

    onEditXml(data) {
      this.showNovoXml = !this.showNovoXml
      this.formDataXml = Object.assign(data,{})
    },


    onEdit(data) {
      this.onGerarArquivoXML([data.id],data.layout);
    },

    onDelete(data) {

      let arrayExcluir = []
      let avulso = false

      if(data && data.id){
        arrayExcluir.push(data.id)

        if(data.avulso == '1' && [328].indexOf(data.tipo_status.id) != -1){
          avulso = true
        }
      }

      if(!arrayExcluir.length){
         this.edAlert(
          "Arquivo indispoível para exclusão.","error"
        );
        return;
      }

      let msg = "O sistema vai excluir "+arrayExcluir.length+" arquivo(s) diretamente no eSocial e o processo não poderá ser desfeito. Deseja prosseguir?"

      if(!data.recibo){
        msg = "O sistema vai excluir "+arrayExcluir.length+" arquivo(s) e o processo não poderá ser desfeito. Deseja prosseguir?"
      }

      this.$confirm(msg,
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.$root.$loading.set(true);
        this.config.loading.content = true;

        var filter = {
          ids: [data.id],
        };

        var empresa_id = null;

        this.post(
          "esocial/" + this.formData.layout+"/deletar",
          { ids: arrayExcluir }
        ).then((result) => {
          result = result[0];
          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {

            if(avulso){
              this.edAlert(
              "Evento excluído com sucesso."
            );
            }
            else{
              this.edAlert(
              "Evento de exclusão enviado para o eSocial."
            );
            }
            
          }
        });
      });
    },

    onGerarLote(data) {
      this.$confirm(
        "O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.content = true;
        this.$root.$loading.set(true);

        var filter = {
          ids: [data.id],
          avulso:this.avulso
        };

        var empresa_id = null;

        if (data.empresa) {
          empresa_id = data.empresa.id;
        } else if (data.ghe && data.ghe.ltcat) {
          empresa_id = data.ghe.ltcat.empresa.id;
        }

        this.get(
          "esocial/lotes/gerar/" + data.layout + "/" + empresa_id,
          { filter: filter }
        ).then((result) => {
          result = result[0];
          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {
            this.edAlert(
              "Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo."
            );
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },

    onGerarArquivoXML(ids,layout = null) {
      this.$confirm(
        "Tem certeza que deseja gerar o xml dos registro(s) selecionados?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.content = true;
        this.$root.$loading.set(true);

        var filter = {
          ids: [ids],
          avulso:this.avulso
        };

        this.get("esocial/" + (layout ? layout : this.formData.layout) + "/gerar-arquivo-xml", {
          filter: filter,
        }).then((result) => {
          result = result[0];

          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {
            this.edMsg("Operação realizada com sucesso");
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },

    onDownloadXML(data) {
      if (data.xml) {
        var contents = data.xml;
        var filename = data.uid + ".xml";
        var contentType = "application/xml";

        var blob = this.b64toBlob(contents, contentType);

        this.download(blob, filename);
      }
    },

    onUpdateUid(data)
    {
      // console.log("onUpdateUid", data);
      this.olduid = data.uid;
      this.novoUid = data.uid;
      this.novoRecibo = data.recibo;
      this.showModalUid = !this.showModalUid;
    },

    saveUid()
    {
      this.$root.$loading.set(true);
      this.config.loading.content = true;

      this.post("esocial/update-uid", 
      { 
        novoUid: this.novoUid, 
        antigoUid: this.olduid,
        novoRecibo: this.novoRecibo,
      }
      ).then((result) => {
          result = result[0];

          this.config.loading.content = false;
          this.$root.$loading.set(false);

          if (result.status == 200) {
              this.showModalUid = !this.showModalUid;
              this.edMsg("Operação realizada com sucesso");

              this.getEsocial();
          }
      });
    },

    onLogs(data) {
      this.formData.item = data;
      this.showLogs = !this.showLogs;
    },

    getEsocialTabela(_search, _page, _pagination) {
      
      this.config.loading.esocial_tabela = true;
      this.config.list.esocial_tabela = [];

      this.get("esocial/tabelas/conteudo/9", {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];

        this.config.loading.esocial_tabela = false;

        if (result.status == 200) {
          this.config.list.esocial_tabela = result.data.data;

          if (this.config.list.esocial_tabela.length && !this.formData.esocial_tabela) {
            this.formData.esocial_tabela = this.config.list.esocial_tabela[0];
            this.formData.layout = this.config.list.esocial_tabela[0].codigo;
          }
        }
      });
    },

    getEsocial (_search, _page, _pagination) {

      this.filterBadge =
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.id_fdt ? 1 : 0) +
        (this.formFilter.id_funcionario ? 1 : 0) +
        (this.formFilter.empresa_envio_automatico ? 1 : 0) +
        (this.formFilter.data_cadastro &&
        this.formFilter.data_cadastro[0] &&
        this.formFilter.data_cadastro[1]
          ? 1
          : 0) +
        (this.formFilter.mostrar && this.formFilter.mostrar.length > 0 ? 1 : 0) +
        (this.formFilter.id_tipo_status && this.formFilter.id_tipo_status.length > 0 ? 1 : 0) +
        (this.formFilter.tp_exa && this.formFilter.tp_exa.length > 0 ? 1 : 0);

        if(this.lote){
        this.formFilter['lote'] = this.lote
      }

      this.formData.search = _search;
      this.formData.page = _page;
      this.formData.pagination = _pagination;

      this.config.loading.table = true;
      this.response = {};
      this.pagination = {};

      this.config.loading.tableAntigo = true;
      this.responseAntigo = {};
      this.paginationAntigo = {};

      if(this.layout){
        this.formData.layout = this.layout
      }

      let url = "esocial/" + this.formData.layout
      if(this.avulso){
        url = "esocial/avulso"
      }

      this.get(url, {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.config.loading.table = false;

        if (result.status == 200) {
          this.pagination = result;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  flex-wrap: nowrap;
}

.esocial-tabs {
  display: flex;
  align-items: stretch;
  gap: 2px;
  background: #f0f1f3;
  border-radius: 8px;
  padding: 3px;
  height: 36px;
  flex: 1 1 calc(50% - 6px);
  min-width: 0;
}

.esocial-tabs__item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.15s, color 0.15s, box-shadow 0.15s;

  i {
    font-size: 11px;
  }

  &:hover:not(.is-active) {
    color: #374151;
  }

  &.is-active {
    background: #fff;
    color: #1f2329;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
}

.esocial-search {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex: 1 1 calc(50% - 6px);
  min-width: 0;
  justify-content: flex-end;
}

.esocial-search__group {
  display: flex;
  align-items: stretch;
  height: 36px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d0d4d9;
  border-radius: 8px;
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 160px;
  transition: border-color 0.15s;

  &:focus-within {
    border-color: #09f;
  }
}

.esocial-search__input {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  padding: 0 12px;
  flex: 1 1 auto;
  min-width: 0;

  i {
    color: #9aa0a8;
    font-size: 12px;
  }

  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 12px;
    color: #1f2329;
    width: 100%;
    height: 100%;

    &::placeholder {
      color: #9aa0a8;
    }
  }
}

.esocial-search__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--attached {
    height: 100%;
    border: none;
    border-left: 1px solid #d0d4d9;
    border-radius: 0;
    background: #f7f8f9;

    &:hover {
      background: #eef0f2;
    }
  }

  &--filter {
    position: relative;
    color: rgb(168, 121, 31);
    border-color: #f0dfb8;
    background: #fdf8ee;

    &:hover {
      background: #f5e6c3;
    }
  }
}

.esocial-search__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: rgb(168, 121, 31);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?a0b13cc0